module.exports = __webpack_public_path__ + "img/face-downcast-sweat.12dfa03d.svg";